<template>
    <div class='w-full'>
        <form action="" class="default-form flex flex-col" @submit.prevent='submit'>
            <div class="contact-form-honeypot" aria-hidden="true">
                <label for="contact-form-company">Company</label>
                <input
                id="contact-form-company"
                v-model="company"
                type="text"
                name="company"
                tabindex="-1"
                autocomplete="off"
                >
            </div>

            <div
            class="default-form__row flex  flex-col md:flex-row"
            :class="{'lg:justify-center' : formCenter}"
            >
                <input
                required
                v-model='name'
                type="text"
                class='text-center rounded-full form-name'
                :placeholder="$t('contactForm.name')"
                >
            </div>


            <div
            class="default-form__row flex  flex-col md:flex-row"
            :class="{'lg:justify-center' : formCenter}"
            >
                <input
                required
                v-model='phone'
                type="text"
                class='text-center rounded-full'
                :placeholder="$t('contactForm.phone')"
                >
                <input
                required
                v-model='email'
                type="text"
                class='text-center rounded-full'
                :placeholder="$t('contactForm.email')"
                >
            </div>


            <div
            class="default-form__row flex flex-col md:flex-row"
            :class="{'lg:justify-center' : formCenter}"
            v-if="showFieldDate || showFieldNumberOfPersons"
            >
                <input
                required
                v-model='date'
                type="text"
                class='text-center rounded-full'
                :placeholder="$t('contactForm.date')"
                v-if="showFieldDate"
                >
                <input
                required
                v-model='numberOfPersons'
                type="text"
                class='text-center rounded-full'
                :placeholder="$t('contactForm.persons')"
                v-if="showFieldNumberOfPersons"
                >
            </div>


            <div
            class="default-form__row flex"
            :class="{'lg:justify-center' : formCenter}"
            >
                <textarea
                class="w-full"
                v-model='message'
                :placeholder="$t('contactForm.message')">
                </textarea>
            </div>

            <div
            class="flex"
            :class="{'lg:justify-center' : formCenter}"
            >
                <button
                type='submit'
                class='bg-blue text-white rounded-full'
                :class="{
                    'lower-opacity-and-pointer-events-none' : status !== 'default'
                }"
                >

                <span v-if='status == "default"'>{{$t('contactForm.send')}}</span>
                <span v-if='status == "error"'>{{$t('contactForm.error')}}!</span>
                <span v-if='status == "sending"'>{{$t('contactForm.sending')}}...</span>
                <span v-if='status == "sent"'>{{$t('contactForm.sent')}}.</span>

                </button>
            </div>

            <p
            v-if="responseMessage"
            class="contact-form-response-error"
            role="alert"
            >
                {{ $t(responseMessage) }}
            </p>
        </form>
    </div>
</template>
<script>
import axios from 'axios'
import toastr from 'toastr'
import { load } from 'recaptcha-v3'

export default {
    props : {
        boatId : {
            Type : [Number, null],
            required : false,
            default : null
        },
        title : {
            Type : [String, null],
            required : false,
            default : null
        },
        formCenter : {
            required : false,
            default : true
        },
        showFieldDate : {
            type : Boolean,
            required : false,
            default : true
        },
        showFieldNumberOfPersons : {
            type : Boolean,
            required : false,
            default : true
        }
    },

    data(){
        return {
            status : 'default',
            name : '',
            email : '',
            phone : '',
            date : '',
            numberOfPersons : '',
            message : '',
            company : '',
            responseMessage : ''
        }
    },


    methods : {
        async submit(){
            this.responseMessage = ''

            if(!this.name){
                toastr.error(this.$t('contactForm.toastr.nameRequired'))
                return
            }
            if(!this.email){
                toastr.error(this.$t('contactForm.toastr.emailRequired'))
                return
            }

            this.status = 'sending'

            try {
                const token = await this.getRecaptchaToken()
                const { data: recaptcha } = await axios.post('/recaptcha/score', {
                    token,
                    action: 'contact_form_submit'
                })

                if(recaptcha.score < 0.5){
                    toastr.error(this.$t('contactForm.toastr.recaptchaFailed'))
                    this.status = 'default'
                    return
                }

                const { data } = await axios.post('/contact', {
                    title : this.title,
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    date: this.date,
                    number_of_persons: this.numberOfPersons,
                    message: this.message,
                    boat_id : this.boatId,
                    company: this.company
                })

                toastr.success(data.status)
                this.status = 'sent'
            } catch (error) {
                const message = error.response?.data?.status || this.$t('contactForm.toastr.error')
                const displayMessage = error.response?.status === 402
                    ? this.$t(message)
                    : message

                if (error.response?.status === 402) {
                    this.responseMessage = message
                }

                toastr.error(displayMessage)
                this.status = 'error'
                setTimeout(()=>{
                    this.status = 'default'
                }, 5000)
                console.log(error);
            }
        },

        async getRecaptchaToken(){
            const siteKey = __RECAPTCHA_SITE_KEY__

            if (!siteKey) {
                throw new Error('Missing reCAPTCHA site key')
            }

            const recaptcha = await load(siteKey)

            return recaptcha.execute('contact_form_submit')
        }
    }
}
</script>

<style>
    .contact-form-honeypot {
        position: absolute;
        left: -9999px;
        width: 1px;
        height: 1px;
        overflow: hidden;
    }

    .contact-form-response-error {
        margin-top: 1rem;
        color: #dc2626;
        text-align: center;
    }

    .lower-opacity-and-pointer-events-none{
        opacity: .3;
        pointer-events: none;
    }
</style>
